module.exports = __webpack_public_path__ + "static/media/4-mobile.5c9a31fa.jpg";